import { useState, useEffect } from "react";
const useLocalStorage = (key, defaultValue) => {
  const getInitialValue = () => {
    if (typeof window === "undefined")
      return defaultValue;
    try {
      const item = window.localStorage.getItem(key);
      const result = item ? JSON.parse(item) : defaultValue;
      return result;
    } catch (e) {
      console.warn(`Error when getting initial value with key “${key}”:`, e);
      return defaultValue;
    }
  };
  const [storedValue, setValue] = useState(getInitialValue);
  useEffect(() => {
    if (typeof window === "undefined")
      return;
    try {
      if (storedValue !== void 0) {
        window.localStorage.setItem(key, JSON.stringify(storedValue));
      } else {
        window.localStorage.removeItem(key);
      }
    } catch (err) {
      console.warn(`Error when setting/removing item with key “${key}”:`, err);
    }
  }, [key, storedValue]);
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key !== key || e.storageArea !== window.localStorage)
        return;
      try {
        setValue(e.newValue ? JSON.parse(e.newValue) : void 0);
      } catch (err) {
        console.warn(`Error changing storage with key “${key}”:`, err);
      }
    };
    if (typeof window === "undefined")
      return;
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [key]);
  return [storedValue, setValue];
};
export {
  useLocalStorage
};
